import styled from 'styled-components'

export const StyledPinSpan = styled.span<{ isPinned: boolean; isTODetails?: boolean }>`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    width: 14px;
    height: 14px;
    fill: ${({ isPinned, theme }) => (isPinned ? theme.green : '#6B6B6B')};
    &:hover {
      fill: ${({ theme }) => theme.getColorWithOpacity('green', 90)};
    }
  }
`
